import { ReactElement } from 'react';
import { styled } from 'styled-components';
import type { Recording } from '@minutes-system/backend/src/api/recordings/schema';
import RecordingCard from './RecordingCard';

const CardGridBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  align-content: start;
`;

interface Props {
  recordings: Recording[];
}

const CardGrid = ({ recordings }: Props): ReactElement => (
  <CardGridBlock>
    {recordings.map(recording => (
      <RecordingCard key={recording.id} recording={recording} />
    ))}
  </CardGridBlock>
);

export default CardGrid;
